/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 利用年齢制限パネル
 *
 * @author ykobayashi
 * @copyright Copyright 2022 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-age-limit-exclude-pane">

  <el-main class="main-area">
    <div class="age-limit-text" v-html="ageLimitText">
    </div>
  </el-main>

  <el-footer class="footer-area" height="auto">
    <el-button type="primary" class="age-limit-close-button" @click="doclose">{{"チャットを終了する"}}</el-button>
  </el-footer>

</el-container>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Button
} from 'element-ui'

export default {
  name: 'FcAgeLimitExcludePane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-button': Button
  },
  data() {
    return {}
  },
  computed: {
    /**
     * エラー表示
     * @return {string}
     */
    ageLimitText() {
      return this.$config.ageLimitDisplayConfig.ageLimitText
    }
  },
  methods: {
    /**
     * チャットの終了処理
     */
    doclose() {
      this.$emit('ageLimitClose')
    }
  }
}
</script>

<style scoped>
.fc-age-limit-input-form-pane {
  height: auto;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.footer-area {
  padding: 10px;
  background: #99a9bf;
}

.age-limit-check-button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/ageLimit/FcAgeLimitExcludePane.vue